<template>
  <MainWrapper>
    <div class="single-master-page">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <h3 class="mb-30">Мои учреждения</h3>
                    <div class="gray-line mb-20"></div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12">
                    <div class="white-panel pt-20 pb-20 pr-20 pl-20">
                        <div class="container-fluid">
                            <div class="row">
                                <div class="tabs mb-30">
                                    <h4 class="mb-20">Создание учреждения</h4>
                                    <div class="light-gray-line"></div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-6 no-p">
                                    <p class="dark-body-text mb-10">Данные учреждения</p>
                                    <p class="mb-30">Заполните все поля. Это необходимое условие для записи к специалистам и обеспечению безопасности вашей учетной записи.</p>
                                    <!--
                                    <div class="spec-photo mb-10" :style="{'background-image': `url(${this.companyData.photo})`}"></div>
                                    <input type="file" @change="pickPhoto($event.target.name, $event.target.files)" id="photo-upload" accept="image/*" class="input-file">
                                    -->
                                    <img v-if="companyData.photo !== ''" :src="companyData.photo" class="mb-15" style="width:200px;height:200px">
                                    <p class="mb-15">Фото учреждения будет отображаться на странице учреждений и на вашей персональной странице.</p>

                                    <avatar-cropper
                                            :labels="userAvatarLabels"
                                            @uploaded="handleUploaded"
                                            trigger="#pick-avatar"
                                            :upload-url="siteUrl+'/content/upload/photo'" />
                                    <div class="button-wrapper mb-15">
                                        <Button id="pick-avatar" type="gray" class="mr-10" text="Загрузить"  />
                                    </div>

                                    <!--
                                    <div class="button-wrapper mb-15">
                                        <label for="photo-upload"><Button type="gray" class="mr-10" text="Загрузить"  /></label>
                                    </div>
                                    -->
                                    <div class="input-wrapper mb-10">
                                        <input class="rounded-input" type="text" v-model="companyData.name" placeholder="Название компании" />
                                    </div>
                                    <div class="input-wrapper mb-10">
                                        <input class="rounded-input" type="mail" v-model="companyData.email" placeholder="example@example.com" />
                                    </div>
                                    <div class="input-wrapper mb-10" v-for="(p, i) in companyData.contacts" :key="i">
                                        <masked-input v-model="p.phone" mask="\9\9\6 111 11 11 11" placeholder-char=" " placeholder="Введите телефон" type="tel" class="rounded-input mr-15" />
                                        <!--<input class="rounded-input mr-15" type="tel" v-model="p.phone" placeholder="996 556 088 891" />-->
                                        <span class="red-body-text pointer" @click="unsetPhone(i)">Удалить</span>
                                    </div>
                                    <div class="button-wrapper mb-15">
                                        <Button type="gray" class="mr-10"  @click="companyData.contacts.push({ phone: '' })" text="Добавить номер" />
                                    </div>
                                    <p class="gray-body-text mb-15">Ваш адрес</p>
                                    <div class="input-wrapper mb-30">
                                        <!--<cascading-address></cascading-address>-->
                                        <select v-model="addr_a" class="rounded-input mr-10" style="width:150px;">
                                            <option value="" selected disabled>Выберите</option>
                                            <option value="Бишкек">Бишкек</option>
                                            <option value="Кант">Кант</option>
                                        </select>
                                        <input v-model="addr_b" class="rounded-input mr-10" type="text" placeholder="Район или улица" />
                                        <input v-model="addr_c" class="rounded-input" type="text" placeholder="№ дома" style="width:100px" />
                                    </div>
                                    <!---->
                                    <!--<textarea class="mb-15" placeholder="г. Бишкек ул. Исанова 70а" v-model="companyData.street_address"></textarea>-->
                                    <p class="gray-body-text mb-15">Краткое описание отображается на странице всех специалистов</p>
                                    <vue-editor id="short_info" v-model="companyData.short_info" :editorToolbar="customToolbar" class="mb-15" placeholder="Краткое описание ваших услуг"></vue-editor>
                                    <!--<textarea class="mb-15" placeholder="Краткое описание ваших услуг" v-model="companyData.short_info"></textarea>-->
                                    <p class="gray-body-text mb-15">Полное описание отображается у вас на странице</p>
                                    <vue-editor id="full_info" v-model="companyData.full_info" :editorToolbar="customToolbar" class="mb-15" placeholder="Полное описание ваших услуг"></vue-editor>
                                    <!--<textarea class="mb-15" placeholder="Полное описание ваших услуг" v-model="companyData.full_info"></textarea>-->
                                    <p class="gray-body-text mb-15">Список услуг учреждения</p>

                                    <div v-if="companyData.categories.length > 0" class="input-wrapper mb-10" v-for="item, i in companyData.categories" :key="item.id">
                                        <input class="rounded-input mr-15" style="background:#e0e0e0" type="text" :value="item.name" disabled />
                                        <span @click="unsetCategories(i)" class="red-body-text pointer">Удалить</span>
                                    </div>

                                    <div class="input-wrapper">
                                        <select class="rounded-input" v-model="cat_level1" @change="setCategoriesLevel2()">
                                            <option value="0" disabled>Выберите категорию</option>
                                            <option v-for="cat, i in categories" :key="cat.id" :value="cat.slug">{{ cat.name }}</option>
                                        </select>
                                    </div>
                                    <div v-if="level2.length > 0" class="input-wrapper mt-10">
                                        <select class="rounded-input" v-model="cat_level2" @change="setCategories()">
                                            <option value="0" disabled>Выберите категорию</option>
                                            <option v-for="cat, i in level2" :key="cat.id" :value="cat.id+':::'+cat.name+':::'+cat.slug">{{ cat.name }}</option>
                                        </select>
                                    </div>
                                    <CustomMap 
                                        :lat="this.companyData.latitude"
                                        :lng="this.companyData.longitude"
                                        :center="{ lat: 42.8717873, lng: 74.6131377 }"
                                        @setGeolocation="handleLocation"
                                    />
                                    <div class="input-wrapper mb-30">
                                        <Button @click="getGeoLocation" type="gray" class="mr-10" text="Определить моё местоположение" />
                                    </div>
                                    <p class="gray-body-text mb-15">Ваши сертификаты</p>
                                    <div v-if="companyData.certificate.length > 0" class="mb-15">
                                        <div class="mr-15" v-for="s,i in companyData.certificate" :key="i" style="display:inline-block">
                                            <a :href="s.url" target="_blank">
                                                <img style="height:170px" :src="s.url" />
                                            </a>
                                            <p style="cursor:pointer" @click="unsetSertificate(i)">Удалить</p>
                                        </div>
                                    </div>
                                    <input type="file" @change="setSertificate($event.target.files)" id="sertificate-upload" accept="image/*" class="input-file">
                                    <div class="input-wrapper mb-30">
                                        <label for="sertificate-upload">
                                            <Button type="gray" class="mr-10" text="Загрузить" />
                                        </label>
                                    </div>
                                    <p class="gray-body-text mb-15">Ваше портфолио</p>
                                    <div v-if="companyData.portfolio.length > 0" class="mb-15">
                                        <div class="mr-15" v-for="p,i in companyData.portfolio" :key="i" style="display:inline-block">
                                            <a :href="p.url" target="_blank">
                                                <img style="height:170px" :src="p.url" />
                                            </a>
                                            <p style="cursor:pointer" @click="unsetPortfolio(i)">Удалить</p>
                                        </div>
                                    </div>
                                    <input type="file" @change="setPortfolio($event.target.files)" id="portfolio-upload" accept="image/*" class="input-file">
                                    <div class="input-wrapper mb-30">
                                        <label for="portfolio-upload">
                                            <Button type="gray" class="mr-10" text="Загрузить" />
                                        </label>
                                    </div>
                                </div>
                                <div class="col-lg-12 no-p">
                                    <div class="button-wrapper mt-30 mb-30">
                                        <Button type="blue" text="Создать" @click="createCompany" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
        </div>
    </div>
  </MainWrapper>
</template>
<style lang="stylus" scoped>
    @import '../../styles/main.core.vars.styl';

    .icon
        font-size: 18px

    .single-filter
        display: inline-flex
        align-items: center
        .filter-icon
            width: 38px
            height: 38px
            display: inline-flex
            align-items: center
            justify-content: center
            border-radius: 100%
            border: 1px solid cyan_dark_color
            color: cyan_dark_color

    textarea
        border-radius: 8px
        border: 1px solid $light_gray
        padding: 10px 15px
        width: 500px
        max-width: 100%
        min-height: 150px

    .services-list
        width: 500px
        max-width: 100%

    .map-wrapper
        overflow: hidden
        border-radius: 4px
        width: 820px
        max-width: 100%

    input[type="file"]
        display: none

    .spec-photo
        width: 70px
        height: 70px
        background: #ccc
        border-radius: 100%
        background-size: cover
</style>
<script>
    import { Component, Vue, Watch } from "vue-property-decorator";
    import { VueEditor } from 'vue2-editor';
    import AvatarCropper from "vue-avatar-cropper";
    import axios from 'axios';
    import MaskedInput from 'vue-masked-input';

    import Button from '@/components/Button.vue';
    import CustomMap from '@/components/CustomMap'
    import News from '@/components/News.vue';
    import Paginator from '@/components/Paginator.vue';

    import MainWrapper from '@/wrappers/MainWrapper.vue';
    
    import http from '@/methods/http.ts';
    import { mapState } from 'vuex'

    @Component({
        components: {
            MainWrapper,
            Button,
            News,
            Paginator,
            AvatarCropper,
            MaskedInput,
            VueEditor,
            CustomMap
        },
        computed: mapState(['authenticated']),
        beforeRouteEnter(to, from, next) {
            next(vm => {
                if (vm.authenticated) {
                    return true;
                }
                console.log({ to, from })
                setTimeout(() => {
                    vm.$store.commit('notificate', { text: 'Авторизуйтесь для доступа к этой странице', type: 'error' });
                }, 500);
                vm.$router.push(from.path)
            })
        }
    })
    export default class CompanySettings extends Vue {

        data() {
            return {
                customToolbar: [
                    ['bold', 'italic', 'underline'],
                    [{ 'list': 'ordered'}, { 'list': 'bullet' }]
                ]
            }
        }

        tab = 3;

        siteUrl = '';

        addr_a = '';
        addr_b = '';
        addr_c = '';

        center = {lat: 42.866044, lng: 74.595645};

        m = {
            position: {lat: 42.866044, lng: 74.595645},
        };

        photo = '';
        categories = [];
        level2 = [];
        level3 = [];
        cats = 0;
        cat_level1 = 0;
        cat_level2 = 0;
        cat_level3 = 0;

        userAvatarLabels = { submit: "Сохранить", cancel: "Отменить" };

        companyData = {
            street_address: "",
            short_info: "",
            name: "",
            email: '',
            contacts: [],
            categories: [],
            full_info: "",
            photo: "",
            longitude: "",
            latitude: "",
            certificate: [],
            portfolio: []
        };

        pickPhoto(names, files) {
            let data = new FormData();

            data.append('file', files[0]);

            axios.post('https://checkin.kg/api/v1/files/upload/', data, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                }
            }).then(r => { 
                this.photo = r.data.file; 
                this.companyData.photo = r.data.id; 
            });
        }

        handleUploaded(resp) {
            this.companyData.photo = resp.url;
        }

        unsetPhone(idx) {
            this.companyData.contacts.splice(idx, 1);
        }

        unsetCategories(idx) {
            this.companyData.categories.splice(idx, 1);
        }

        setCategories() {
            let params = this.cat_level2;
            params = params.split(':::');

            this.companyData.categories.push({
                id: params[0],
                name: params[1],
                slug: params[2]
            });

            this.cat_level1 = 0;
            this.cat_level2 = 0;
            this.cat_level3 = 0;
            this.level2 = [];
            this.level3 = [];
        }

        setCategoriesLevel2() {
            this.cat_level2 = 0;
            this.cat_level3 = 0;
            this.level2 = [];
            this.level3 = [];
            let url = 'categories/'+this.cat_level1;
            http(url, 'get', false, {}).then(r => {
                this.level2 = r.data.children;
            })
        }

        setCategoriesLevel3() {
            let url = 'categories/'+this.cat_level2;
            http(url, 'get', false, {}).then(r => {
                this.level3 = r.data.children;
            })
        }

        getCategories() {
            http('categories/main', 'get', false, {}).then(r => {
                this.categories = r.data;
            })
        }

        createCompany() {
            if (this.addr_a === '' || this.addr_b === '' || this.addr_c === '') {
                this.$store.commit('notificate', { text: 'street_address data error', type: 'error' });
                return false;
            }
            this.companyData.street_address = this.addr_a+':::::'+this.addr_b+':::::'+this.addr_c;
            http('company/create', 'post', this.$store.state.token, this.companyData).then(r => {
                if (r.data.success === true) {
                    this.$router.push("/user/companies");
                    //this.$store.commit('notificate', {type: 'info', text: 'Компания успешно создана'});
                }
            }).catch(error => {
                this.$store.commit('notificate', { text: error.response.data.message, type: 'error' });
            });
        }

        detectMyPos() {
            navigator.geolocation.getCurrentPosition((g) => {
                this.m.position.lat = g.coords.latitude;
                this.m.position.lng = g.coords.longitude;
            })
        }

        unsetSertificate(k) {
            this.companyData.certificate.splice(k, 1);
            //this.$store.commit('notificate', { text: 'Сертификаты обновлены', type: 'action' });
        }

        setSertificate(files) {
            let data = new FormData();
            data.append('file', files[0]);
            http('content/upload/certificate', 'post', this.$store.state.token, data, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                }
            }).then(r => {
                if (r.data.success === true) {
                    this.companyData.certificate.push({
                        'file_ptr_id': 1, //r.data.file_ptr_id,
                        'url': r.data.url
                    });
                    this.$store.commit('notificate', { text: 'Сертификаты обновлены', type: 'action' });
                }
            }).catch(r => {
                this.$store.commit('notificate', { text: 'Введены неверные данные', type: 'error' });
            });
        }

        unsetPortfolio(k) {
            this.companyData.portfolio.splice(k, 1);
            //this.$store.commit('notificate', { text: 'Портфолио обновлено', type: 'action' });
        }

        setPortfolio(files) {
            let data = new FormData();
            data.append('file', files[0]);

            http('content/upload/portfolio', 'post', this.$store.state.token, data, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                }
            }).then(r => {
                if (r.data.success === true) {
                    this.companyData.portfolio.push({
                        'id': r.data.id,
                        'url': r.data.url
                    });
                    this.$store.commit('notificate', { text: 'Портфолио обновлено', type: 'action' });
                }
            }).catch(r => {
                this.$store.commit('notificate', { text: 'Введены неверные данные', type: 'error' });
            });
        }

        created() {
            if(window.location.hostname === 'localhost') {
                this.siteUrl = 'http://api.checkin.local/api/v1';
            } else {
                this.siteUrl = 'https://api.checkin.kg/api/v1';
            }
            this.getCategories();
        }

        handleLocation({ lat, lng }) {
            console.group('handleLocation');
            this.companyData.latitude = lat;
            this.companyData.longitude = lng;
            console.log('updated master', this.master)
            this.$store.commit('notificate', { text: 'Ваше местоположение добавлено!', type: 'action' });
        }
    }
</script>